module.exports = __webpack_public_path__ + "img/3.1.fb906adf.jpg";